export default __webpack_public_path__ + "static/media/deactivae.48634056.svg";